import { DocActions } from '@store/actions';
import { clearDocumentUrl, setDocumentUrl } from '@store/actions/document.action';
import { createReducer } from 'typesafe-actions';

export interface DocumentState {
    documentUrl: string;
}

export const initState: DocumentState = {
    documentUrl: ''
};

export const docReducer = createReducer<DocumentState, DocActions>(initState)
    .handleAction(setDocumentUrl, (state, action) => ({
        ...state,
        documentUrl: action.payload
    }))
    .handleAction(clearDocumentUrl, (state, action) => ({
        ...state,
        documentUrl: ''
    }));
